import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { comboboxChipsOverflowStyles } from './styles/combobox-chips-overflow.styles';
import type { ComboboxChipsOverflowPropsInterface } from './types/combobox-chips-overflow.types';

/**
 * @since 10.0.0
 */
export const ComboboxChipsOverflow = forwardRef<
  HTMLSpanElement,
  ComboboxChipsOverflowPropsInterface
>((props: ComboboxChipsOverflowPropsInterface, forwardedRef) => {
  const { className, css: cssProp, ...rest } = props;
  const styles = css(comboboxChipsOverflowStyles, cssProp);
  return (
    <span
      ref={forwardedRef}
      data-c11n-component="Combobox.ChipsOverflow"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', 'c11n_combobox__chips-overflow', styles, className)}
      {...rest}
    />
  );
});

ComboboxChipsOverflow.displayName = 'Combobox.ChipsOverflow';
